import axios from "axios";
import Option from "./Option.class";


/**
 * @classdesc Liste des options d'un module
 * @kind class
 * @export
 * @prop {int} id_module - Id du module
 * @prop {array} list - Liste des options
 * @class List_Options
 */
export default class List_Options {
  id_module;
  list = [];

  /**
   *  Initialise la liste des options
   *
   * @constructs
   * @param id - Id du module
   * @memberof List_Options
   */
  constructor(id) {
    this.id_module = id;
  }

  /**
   * Appel API pour charger la liste
   *
   * @return {boolean} success
   * @async
   * @memberof List_Options
   */
  async fetch(has_preinscriptions = false) {
    const param_preinscriptions = has_preinscriptions ? "&has_preinscriptions=1" : "";
    let res = await axios.get("/options/get.php?id_module=" + this.id_module + param_preinscriptions);
    if (res.data.error) {
      console.log(res.data.error);
      return await false;
    } else {
      this.set(res.data);
      return await true;
    }
  }


  /**
   * Créer la liste des options du module
   *
   * @param {array} data
   * @memberof List_Options
   */
  set(data) {
    for (let i = 0; i < data.length; i++) {
      let option = new Option();
      option.set(data[i]);
      if (this.list.find(o => o.id == option.id) == undefined) {
        this.list.push(option);
      }
    }
  }

  filter_visible_accueil() {
    this.list = this.list.filter(option => option.visible_accueil == '1');
  }

  filter_availables(inscription) {
    for (let i = this.list.length - 1; i >= 0; i--) {
      let option = this.list[i];
      if (!option.has_liaisons()) { // Si l'option n'a pas de liaisons, elle est disponible
        continue;
      }
      if (option.is_available_with_selected_course(inscription)) { // Si l'option est disponible avec la course sélectionnée, elle est disponible
        continue;
      }
      if (option.is_available_with_selected_pack(inscription)) { // Si l'option est disponible avec le pack sélectionné, elle est disponible
        continue;
      }
      // Sinon, elle n'est pas dispo, on supprime la quantité du panier si elle existe, et elle n'est pas disponible
      if (option.quantite_souhaite > 0) {
        option.quantite_souhaite = 0;
      }
      this.list.splice(i, 1);
    }
  }

  filter_availables_options(selected_parcours, selected_packs) {
    for (let i = this.list.length - 1; i >= 0; i--) {
      let option = this.list[i];
      if (!option.has_liaisons()) { // Si l'option n'a pas de liaisons, elle est disponible
        continue;
      }

      if (option.is_available_with_selected_course(selected_parcours)) { // Si l'option est disponible avec la course sélectionnée, elle est disponible
        continue;
      }
      if (option.is_available_with_selected_pack(selected_packs)) { // Si l'option est disponible avec le pack sélectionné, elle est disponible
        continue;
      }

      // Sinon, elle n'est pas dispo, on supprime la quantité du panier si elle existe, et elle n'est pas disponible
      if (option.quantite_souhaite > 0) {
        option.quantite_souhaite = 0;
      }
      this.list.splice(i, 1);
    }
  }

  filter_availables_for_changement_parcours() {
    for (let i = this.list.length - 1; i >= 0; i--) {
      let option = this.list[i];
      if (option.disponible_changement == "0") {
        this.list.splice(i, 1);
      }
    }
  }

  group_by(key) {
    let groups = [];
    for (let i = 0; i < this.list.length; i++) {


      let option = this.list[i];
      let group = option.get_metadata(key);
      if (group == false) {
        group = "Sans groupe";
      }
      let group_found = false;
      for (let j = 0; j < groups.length; j++) {
        if (groups[j].name == group) {
          groups[j].list.push(option);
          group_found = true;
          break;
        }
      }
      if (!group_found) {
        groups.push({ name: group, list: [option] });
      }

    }
    return groups;
  }

  filter_billetterie() {
    for (let i = this.list.length - 1; i >= 0; i--) {
      let allowed = false;
      let liaisons_course = this.list[i].list_liaisons_course;
      if (liaisons_course.length == 0) {
        allowed = true;
      }

      if (!allowed) {
        this.list.splice(i, 1);
      }
    }
  }
  add_from_transferable(transferable_inscription) {
    for (let i = 0; i < transferable_inscription.commande_options.length; i++) {
      let commande_option = transferable_inscription.commande_options[i];
      if (commande_option.type == 'option') {
        for (let j = 0; j < this.list.length; j++) {
          if (this.list[j].id == commande_option.id_item) {
            this.list[j].quantite_souhaite = commande_option.quantite;
          }
        }

      }
    }
  }

  update_cart(vip_ins = null, lien_groupe = null) {
    let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
    for (let i = 0; i < this.list.length; i++) {
      let item_cart = this.list[i].update_cart(vip_ins, lien_groupe);
      cart.nb_articles += parseInt(item_cart.nb_articles);
      cart.prix += parseFloat(item_cart.prix);
      cart.prix_regulier += parseFloat(item_cart.prix_regulier || item_cart.prix || 0);
    }
    this.cart = cart;
    return cart;
  }

  /* ----------------------- */


  /**
   * Initializes the list of options from the main store.
   *
   * @param {Array} options - An array of option objects to initialize from.
   */
  initialize_from_mainstore(options) {
    for (let i = 0; i < options.length; i++) {
      let option = new Option();
      option.set(options[i]);
      if (this.list.find(o => o.id == option.id) == undefined) {
        this.list.push(option);
      }
    }
  }

  toggle_from_dossard_bourse(dossard_bourse) {
    let options_in_dossard_bourse = dossard_bourse.options.filter(option => option.type == 'option');
    for (let i = 0; i < options_in_dossard_bourse.length; i++) {
      let option = options_in_dossard_bourse[i];
      for (let j = 0; j < this.list.length; j++) {
        if (this.list[j].id == option.id_item) {
          this.list[j].quantite_souhaite = option.quantite;
          break;
        }
      }
    }
  }

  /**
   * Checks if the list has any options.
   *
   * @returns {boolean} True if the list has one or more options, otherwise false.
   */
  has_options() {
    return this.list.length > 0;
  }

  getSimplifiedData() {
    if (this.cart?.nb_articles == 0) return null;
    let infos = {};
    infos.prix = this?.cart?.prix;
    infos.list = [];
    for (let i = 0; i < this.list.length; i++) {
      const option = this.list[i];
      let option_infos = option.getSimplifiedData();
      if (option_infos) {
        infos.list.push(option_infos);
      }
    }
    return infos;
  }


}
